import { render, staticRenderFns } from "./FlowPlatform.vue?vue&type=template&id=e4251e4e&scoped=true&"
import script from "./FlowPlatform.vue?vue&type=script&lang=js&"
export * from "./FlowPlatform.vue?vue&type=script&lang=js&"
import style0 from "./FlowPlatform.vue?vue&type=style&index=0&id=e4251e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4251e4e",
  null
  
)

export default component.exports